import { useEffect, useRef } from 'react';
import { graphql, useFragment } from 'react-relay';
import { trackUserAbTestEvent } from './ab';
import { useUserAbTest_userAbTest$key } from './__generated__/useUserAbTest_userAbTest.graphql';

const userAbTestFragment = graphql`
    fragment useUserAbTest_userAbTest on UserAbTest {
        testName
        isActive
        variantPercentage
        isInVariant
    }
`;

/**
 * hook to fire tracking for user ab tests (SELLERTOOLS-11337)
 * @param userAbTestRef
 * @returns {boolean} true if user should receive variant, false if user should receive control
 */
export function useUserAbTest(userAbTestRef: useUserAbTest_userAbTest$key | null): boolean {
    const { testName, isActive, variantPercentage, isInVariant } =
        useFragment(userAbTestFragment, userAbTestRef) ?? {};

    const isInitialRender = useRef(true);
    useEffect(() => {
        if (
            isInitialRender.current &&
            isActive &&
            testName &&
            typeof variantPercentage === 'number' &&
            typeof isInVariant === 'boolean'
        ) {
            trackUserAbTestEvent({
                testName,
                isInVariant,
                variantPercentage,
            });
        }
        isInitialRender.current = false;
    }, [isActive, testName, isInVariant, variantPercentage]);

    return Boolean(isActive && isInVariant);
}
